/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import NameBlock from "./Steps/NameBlock";
import DefineArguments from "./Steps/DefineArguments";
import AssignArguments from "./Steps/AssignArguments";
import './index.scss';
import {blockToXmlSanitized, addTenantToPayload} from "../../utils";
import {sanitizeRestBlocksForLibrary} from "../../utils/restBlockLibrarySanitizer";
import BaseSaveModal from "./BaseSaveModal";

export class SaveModal extends BaseSaveModal {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            blockToSaveXml: null,
            refresh: false
        };
        this._handleDefineArgumentsNext = this._handleDefineArgumentsNext.bind(this);
        this._handleAssignBlocksNext = this._handleAssignBlocksNext.bind(this);
    }

    onComponentWillUnmount() {
        Blockly.Workspace.getAll()[0].markFocused();
    }

    _handleDefineArgumentsNext (blockArgs, blockDom) {
        this.setState({ blockArgs });
        let blockText = Blockly.Xml.domToText(blockDom);
        this.setState({ blockToSaveXml: blockText });
        this._incrementStep();
    }

    _handleAssignBlocksNext (block) {
        const { blockInfo } = this.state;

        const sanitizedBlock = blockToXmlSanitized(block);
        // Remove credentials from REST blocks before saving them to My Libraries.
        sanitizeRestBlocksForLibrary(sanitizedBlock);
        let xml_text = Blockly.Xml.domToText(sanitizedBlock);

        let libraryId = this._findLibraryId(blockInfo.library);

        /* Proceed to save my block */
        const blockPayload = {
            userId: this.props.userId,
            name: blockInfo.name,
            xml: xml_text,
            code: 'currently not available',
            language: 'javascript',
            version: '1.0.0',
            type: 'myBlock',
            keywords: blockInfo.keywords ? blockInfo.keywords.toString() : " ",
            libraryId: libraryId,
            description: blockInfo.description ?  blockInfo.description.toString() : " "
        };
        addTenantToPayload(blockPayload, this.props.tenantId, this.props.snapTenantGuid);
        this.props.saveMyBlock(blockPayload);

        this.props.history.push(`/${globalThis.location.search}`);
    }

    render() {
        if (!this.props.block) { return null; }
        let step = this.state.step;
        const { blockInfo, blockArgs, blockToSaveXml} = this.state;

        return (
            <div id={"save-modal-container"}>
                {
                    step === 1 && <NameBlock
                                    handleCancel={() => {}}
                                    values={blockInfo}
                                    handleNext={this._handleNameBlockNext}
                                    libraries={this.props.libraries}
                                    JSFlag={"Inputs"}
                                    title={"Save Block to Library"}/>
                }
                {
                    step === 2 && <DefineArguments
                                    values={blockArgs}
                                    blockName={blockInfo.name}
                                    block={this.props.block}
                                    step={this.state.step}
                                    toolbox={this.props.toolbox}
                                    type={"blank_block"}
                                    handleBack={this._decrementStep}
                                    handleCancel={() => {}}
                                    handleNext={this._handleDefineArgumentsNext}
                                    description={this.state.blockInfo.description ? this.state.blockInfo.description : ""}
                                    JSFlag={"Inputs"}
                                    title={"Save Block to Library"}/>
                }
                {
                    step === 3 && <AssignArguments
                                    values={blockInfo}
                                    blockName={blockInfo.name}
                                    xmlText = {blockToSaveXml}
                                    args={blockArgs}
                                    handleBack={this._decrementStep}
                                    handleCancel={() => {}}
                                    handleNext={this._handleAssignBlocksNext} />
                }
            </div>
        );
    }
}

SaveModal.propTypes = {
    sendValidatedToParent: PropTypes.func,
    block: PropTypes.object,
    libraries: PropTypes.array,
    userId: PropTypes.string,
    tenantId: PropTypes.string,
    snapTenantGuid: PropTypes.string,
    toolbox: PropTypes.object,
    saveLibrary: PropTypes.func,
    saveMyBlock: PropTypes.func,
    history: PropTypes.object
};

export default withRouter(SaveModal);
